<template>
<div>
  <v-datetime-picker
    :label="placeholder"
    v-model="formatedDate"
    dateFormat="dd/MM/yyyy"
    timeFormat="HH:mm"
    clearText="Limpar"
    @input="updateValueTime"
    v-bind="settings"
    v-on="$on" 
    v-if="time"
    outlined
    :readonly="readOnly"
    :textFieldProps="{
      outlined: true,
      dense: true,
      appendIcon: 'mdi-calendar'
    }"
    :datePickerProps="{
      locale: 'pt-br'
    }"
    :timePickerProps="{
      format: formatTimePicker
    }"
    :disabled="disabled"
    :key="refreshDate"
    :error-messages="error"
  >
    <template slot="dateIcon">
      <v-icon>mdi-calendar</v-icon>
    </template>
    <template slot="timeIcon">
      <v-icon>mdi-clock</v-icon>
    </template>
  </v-datetime-picker>
    
  <v-text-field
    v-model="value"
    :label="placeholder"
    append-icon="mdi-calendar"
    :readonly="readOnly"
    v-bind="settings"
    v-on="$on"        
    outlined
    dense
    v-else-if="readOnly"
    :key="refreshDate"
    :class="error ? 'show-errors' : 'hide-error'"
    :error-messages="error"
  />

  <v-dialog
    v-else
    ref="dialog"
    v-model.lazy="abrirDateModal"
    :return-value.sync="value"
    persistent
    @blur="updateValue"
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model.lazy="formatedDate"
       :label="placeholder"
        append-icon="mdi-calendar"
        :readonly="readOnly"
        v-bind="attrs"
        v-on="on"        
        outlined
        dense
        :class="error ? 'show-errors' : 'hide-error'"
        :error-messages="error"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model.lazy="date"
      scrollable
      locale="pt-br"
      first-day-of-week="1"
      show-week
      :min="minimumDate"
      @dblclick:date="$refs.dialog.save(date)"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="abrirDateModal = false"
      >
        Fechar
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="$refs.dialog.save(date)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "SGPFormDataComponent",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Data"
    },
    
    name: {
      type: String,
      required: true,
    },

    parse: {
      type: Boolean,
      required: false,
      default: true,
    },

    value: {
      type: [String, Number],
      required: true,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    error: {
      type: Boolean,
      required: false,
      default: false
    },

    time: {
      type: Boolean,
      required: false,
      default: true
    },

    formatTimePicker: {
      type: String,
      required: false,
      default: 'ampm'
    },

    minimumDate : {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      abrirDateModal: false,
      parsedDate: '',
      formatedDate: this.formatDate(this.value),
      refreshDate: true
    }
  },

  mounted () {
    if (this.value) {
        this.parseDateInit()
      }
  },

  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    }
  },

  methods: {
    parseDateInit () {
      let dateTimeFormat = 'DD/MM/YYYY HH:mm'
      if (!this.time) {
        dateTimeFormat = 'DD/MM/YYYY'
      }
      this.formatedDate = moment(this.value).format(dateTimeFormat)
    },
    formatDate () {
      if (!this.value) return null
      this.formatedDate = moment(this.value).format('DD/MM/YYYY') // `${day}/${month}/${year}`
    },

    updateValue () {
      if (!this.value) return null

      if (this.parse) {
        this.parsedDate = this.value.split('/').reverse().join('-')
      }

      if (this.time) {
        this.parsedDate = this.value.replace('T', ' ')
      }
      
      this.$emit('input', this.parsedDate)
      this.$emit('change', this.parsedDate)
    },

    updateValueTime () {
      this.parsedDate = moment(this.formatedDate).format('YYYY-MM-DD HH:mm')

      this.$emit('input', this.parsedDate)
      this.$emit('change', this.parsedDate)
    }
  },

  watch: {
    abrirDateModal (val) {
      if (!val) {
        this.formatDate()
        this.updateValue()
      }
    },

    value (val) {
      if (!val) {
        this.formatDate()
        this.updateValue()

        this.formatedDate = val
        this.parsedDate = val
        this.refreshDate = false
      } else {
        this.refreshDate = true
      }
    }
  }

}
</script>

<style scoped>
.hide-error.v-text-field__details{
  display: none !important;
}
</style>